import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import styled from 'styled-components';
import CheckBox from '../checkbox/CheckBox';

const Wrapper = styled.div`
  padding: 12px 16px;
  display: flex;
  justify-content: space-between;
  ${(props) => {
    let result;
    let bgColor = 'background-color: ';
    let textColor;

    if (!props.select) {
      bgColor = props.theme.color.WHITE;
    } else {
      switch (props.selectedColor) {
        case props.theme.color.PRIMARY_BLUE:
          textColor = props.theme.color.WHITE;
          bgColor = props.theme.color.PRIMARY_BLUE;
          break;

        default:
          bgColor = props.theme.color.LIGHT;
          break;
      }
    }

    result = `
      background-color: ${bgColor}; 
      * {
        color: ${textColor && `white`} !important
      }
    `;

    return result;
  }}

  transition: background-color 0.1s ease-in-out;
  border-radius: 4px;
  line-height: initial; // bcz table css property inherited

  ${(props) => {
    let textColor;

    switch (props.hoverColor) {
      case props.theme.color.PRIMARY_BLUE:
        textColor = props.theme.color.WHITE;
        break;

      default:
        break;
    }

    if (!props.disabled) {
      return `
      :hover {
        cursor: pointer;
        background-color: ${props.hoverColor || props.theme.color.LIGHT};
        * {
          color: ${textColor};
        }
      }
      `;
    }
    return 'cursor: default;';
  }}
`;

const TitleText = styled.div`
  font-size: 12px;
  color: ${(props) =>
    props.type === 'header'
      ? props.theme.color.MEDIUM_DARK
      : props.disabled
      ? props.theme.color.MEDIUM
      : props.theme.color.BLACK};
`;

function MenuItem(props, ref) {
  const {
    type,
    style,
    title,
    select,
    selectedColor,
    check,
    onChangeCheck,
    onClick,
    disabled,
    hoverColor,
    children,
  } = props;

  const menuItemRef = useRef(null);

  useImperativeHandle(ref, () => ({
    getHeight: () => menuItemRef.current.offsetHeight,
  }));

  let $El;
  if (children?.length > 0) {
    $El = children;
  } else if (type === 'check') {
    $El = (
      <CheckBox
        ref={ref}
        checked={check}
        onChange={onChangeCheck}
        label={title}
        labelStyle={{ fontSize: 12 }}
      />
    );
  } else if (type !== 'check') {
    $El = (
      <TitleText type={type} disabled={disabled}>
        {title}
      </TitleText>
    );
  }

  return (
    <Wrapper
      ref={menuItemRef}
      style={style}
      type={type}
      select={select}
      selectedColor={selectedColor}
      disabled={disabled}
      hoverColor={hoverColor}
      onClick={() => {
        if (disabled) {
          return;
        }
        onClick();
      }}>
      {$El}
    </Wrapper>
  );
}

export default React.forwardRef(MenuItem);
